<div class="d-flex justify-content-end border-top flex-wrap">
  <span class="btn btn-sm">Actions:</span>
  @if (allowSpare) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['spare']">Spare</a>
  }
  @if (allowUnavailable) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['unavailable']">Unavailable</a>
  }
</div>